import { Description, Message as UIMessage } from "@evergis/ui";
import styled from "styled-components";

export const ProjectCopyOptionsContainer = styled.div`
  margin: 2.25rem 0 1rem;
`;

export const Notice = styled(UIMessage)`
  font: ${({ theme: { fonts } }) => fonts.description};
`;

export const TableStructure = styled.ul`
  position: relative;
  list-style: none;
  margin: 1.65rem 0 0;
  padding: 0;

  &::before {
    content: "";
    border-left: 1px solid rgba(151, 151, 151, 0.28);
    position: absolute;
    top: 2rem;
    left: 1rem;
    height: calc(100% - 3.16rem);
  }
`;

export const TableItem = styled.div`
  display: flex;
  align-items: baseline;
`;

export const TableInformation = styled.div`
  display: flex;
  align-items: baseline;
  width: 36rem;
`;

export const TableIconContainer = styled.div`
  position: relative;
  top: -0.06rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
`;

export const TableTitleContainer = styled.div`
  margin-left: 0.12rem;
`;

export const TableTitle = styled.div`
  position: relative;
  top: -0.08rem;
  color: ${({ theme }) => theme.palette.textPrimary};
  max-width: 28rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TableSubtitle = styled.div`
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme }) => theme.palette.textDisabled};
  height: 0.875rem;
  max-width: 28rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TableControl = styled.div`
  position: relative;
  top: 0.1rem;
  min-width: 20rem;
  max-width: 20rem;
  box-sizing: border-box;

  ${Description} {
    position: relative;
    top: -0.2rem;
  }
`;

export const LayerInformation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  width: 100%;
`;

export const LayerTitle = styled.div`
  display: flex;
  align-items: center;
  padding-right: 1rem;
  height: 2rem;
  box-sizing: border-box;

  button {
    position: relative;
    top: 0.1rem;
  }
`;

export const LayerTitleText = styled.div`
  position: relative;
  max-width: 25.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LayerItem = styled.li<{ isFilterable?: boolean }>`
  display: flex;
  align-items: baseline;
  height: 2.3rem;

  &::before {
    content: "";
    position: relative;
    box-sizing: border-box;
    top: ${({ isFilterable }) => (isFilterable ? "-0.30rem" : "-0.16rem")};
    min-width: ${({ isFilterable }) => (isFilterable ? "1.56rem" : "3.06rem")};
    max-width: ${({ isFilterable }) => (isFilterable ? "1.56rem" : "3.06rem")};
    border-bottom: 1px solid rgba(151, 151, 151, 0.28);
    margin: ${({ isFilterable }) => (isFilterable ? "0 2rem 0 1rem" : "0 0.5rem 0 1rem")};
  }

  ${LayerTitle} {
    margin-left: ${({ isFilterable }) => (isFilterable ? "-2rem" : "0")};
  }

  ${LayerTitleText} {
    top: ${({ isFilterable }) => (isFilterable ? "0.15rem" : "0")};
  }
`;

export const LayerSubtitle = styled.div`
  position: relative;
  top: -0.3rem;
  font: ${({ theme: { fonts } }) => fonts.description};
  color: ${({ theme }) => theme.palette.textDisabled};
  height: 0.875rem;
  max-width: 25.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LayerControl = styled.div`
  position: relative;
  top: 0.1rem;
  min-width: 20rem;
  max-width: 20rem;
`;
